export default "__VITE_ASSET__Bcx6XbcW__$_?url__"